import React from "react";
import { InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";
import { CustomSearchTextField } from "../../../../../Components/CustomMuiComponents";

export default function SearchTipoUsuario({ filter, setFilter }) {
  return (
    <CustomSearchTextField
      placeholder="Buscar"
      size="small"
      fullWidth
      variant="outlined"
      value={filter}
      onChange={(e) => setFilter(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
    />
  );
}
